export enum KonfigurationsTyp {
  NEUE_ROLLE = 'NEUE_ROLLE',
  BESTEHENDE_ROLLEN = 'BESTEHENDE_ROLLEN',
}

export enum RollenAuswahlTyp {
  NEU = 'NEU',
  BESTEHEND = 'BESTEHEND',
}

export enum NutzerAuswahlTyp {
  NEU = 'NEU',
  BESTEHEND = 'BESTEHEND',
}

export interface ZweitpruefungKonfigurationRequest {
  konfigurationsTyp: KonfigurationsTyp;

  neueRolle?: {
    name: string;
    iconname: string;
    immutable: boolean;
    rechte: string[];
    nutzer: {
      typ: NutzerAuswahlTyp.NEU | NutzerAuswahlTyp.BESTEHEND;
      neuerNutzer?: NutzerAnlegenDto;
      nutzerIds?: string[];
    };
  };

  bestehendeRollenIds?: string[];
}

export interface NutzerAnlegenDto {
  vorname: string;
  nachname: string;
  email: string;
  telefonnummer: string;
  rolle: { name: string };
  unternehmenSichtbeschränkt?: boolean;
  sichtberechtigteUnternehmen?: string[];
  erhaltNutzerEMails?: boolean;
}
